import React from 'react';

import styles from './styles';

const Loading = () => {
  return (
    <div style={styles.wrapper}>
      <img src="/images/spinner.gif" alt="Loading"/>
    </div>
  )
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Common/Loading/index.js